/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { getExplorerLink } from "../../config/chains";
import { NFT_ADDR } from "../../config/contracts";
import { useWeb3Context } from "../../hooks/web3Context";
import { getEllipsis } from "../../utils/functions";
import { ETHSVG } from "../../utils/svgs";

function HeroSection() {
  const { chainID } = useWeb3Context();
  return (
    <div className="relative flex justify-center text-primary">
      <img
        src={"/images/inventory/banner.png"}
        alt={""}
        className="max-w-[unset]  3xl:w-full w-[1920px]"
      />
      <div className="absolute left-0 top-0 w-full h-full mintnftGradient" />
      <div className="absolute flex justify-center items-center w-full h-full lg:text-[80px] text-[48px]">
        <div className="flex flex-wrap justify-center text-green">
          <span className="font-semibold">TrueApex</span>&nbsp;Inventory
        </div>
      </div>
      <div className="absolute bottom-0 w-[calc(100%-24px)] max-w-[1362px] mx-auto h-[218px] bg-[#ffffffae] rounded-t-[20px] flex md:justify-between justify-start lg:md:xs:p-[54px_75px_60px_75px] md:xs:p-[54px_40px_60px_40px] xs:p-[24px_40px_20px_40px] p-[24px_24px_20px_24px] md:items-end items-start md:flex-row flex-col">
        <div className="max-w-[587px] mr-5">
          <div className="lg:xs:text-2xl xs:text-lg text-base font-semibold">About</div>
          <div className="lg:xs:text-xl xs:text-base text-sm mt-4">
            <br />
            <br />
          </div>
        </div>
        <a
          className="flex rounded-[30px] lg:xs:w-[354px] xs:w-[280px] w-[260px] lg:h-[55px] h-[40px] items-center bg-[#ffffff] px-[18px] md:mt-0 mt-3"
          target={"_blank"}
          href={getExplorerLink(chainID, "token", NFT_ADDR[chainID])}
          rel="noreferrer"
        >
          <div>{ETHSVG}</div>
          <div className="font-medium ml-2.5 lg:xs:text-base xs:text-sm text-xs">
            {getEllipsis(NFT_ADDR[chainID], 6, 18)}
          </div>
        </a>
      </div>
    </div>
  );
}

export default HeroSection;
